import React from "react";
import { Link } from "react-router-dom";
import { get } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBell,
  faQuestionCircle,
} from "@fortawesome/pro-light-svg-icons";
import {
  Container,
  Navbar,
  Nav,
  Image,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import { ROUTES } from "../../utils";
import { IconDropDown, HeaderPopover } from "../";
import { ReactComponent as UserIcon } from "./user-icon.svg";
import { ReactComponent as VerticalTripleDots } from "./vertical-triple-dots.svg";
import { LoginMenu } from "../api-authorization/LoginMenu";
const BackgroundFilledImage = ({ pct }) => {
  const style = {
    background: `linear-gradient(transparent ${100 - pct}%, red ${100 - pct}%)`,
  };
  return (
    <Image
      height={40}
      width={40}
      rounded
      src="https://storageaccountcore2ad3a.blob.core.windows.net/logoimg/user.png"
    ></Image>
  );
};

const menuList = [
  {
    path: ROUTES.HOME,
    label: "Home",
    childRoutes: [
      ROUTES.COMPANY,
      ROUTES.MANAGE_COMPANY,
      ROUTES.PLAN,
      ROUTES.CREATE_PLAN,
      ROUTES.MANAGE_PLAN,
      ROUTES.MANAGE_ELIGIBILITY,
      ROUTES.MANAGE_EMPLOYEE,
      ROUTES.MANAGE_CENSUS,
      ROUTES.ENROLLMENT,
    ],
  },
  // {
  //   path: ROUTES.DASHBOARD,
  //   label: "Dashboard",
  // },
];

const Header = ({ onMenuChange, seletedRoute, headerName = "Dashboard" }) => {
  return (
    <header style={{ fontWeight: "500", fontSize: "20px" }}>
      <Container fluid>
        <Row className="my-3 ">
          <Link
            to={ROUTES.HOME}
            style={{ width: "215px", paddingLeft: "30px" }}
          >
            <Image src={`/assets/icons/svg/core.svg`} height="31" />
          </Link>

          <Col className="d-flex align-items-center">
            <div className="header-text">{headerName}</div>
          </Col>
          <Col
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <FontAwesomeIcon
              style={{ fontSize: "28px" }}
              icon={faQuestionCircle}
              className="mr-4"
            />
            <FontAwesomeIcon
              style={{ fontSize: "28px" }}
              icon={faBell}
              className="mr-4"
            />

            <IconDropDown
              style={{ zIndex: 200, padding: "0px" }}
              icon={<BackgroundFilledImage pct={0}></BackgroundFilledImage>}
            >
              <HeaderPopover>
                <LoginMenu />
              </HeaderPopover>
            </IconDropDown>

            {/* <FontAwesomeIcon
                  icon={faEllipsisV}
                                   
                /> */}
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Header;
